var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 56,
    viewBox: "0 0 63 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.35 19.7383C47.72 23.8883 50.48 35.5783 42.64 46.4583L42.13 46.9083C39.4 45.3783 36.26 44.5083 32.91 44.5083C25.9 44.5083 19.8 48.3183 16.52 53.9783H49.3C48.29 52.2383 47.01 50.6683 45.52 49.3283",
    stroke: "#003D6A",
    strokeWidth: 2.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4297 33.5508C15.0197 37.1508 16.5097 41.4308 19.9397 45.2508",
    stroke: "#003D6A",
    strokeWidth: 2.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9099 10.61C51.6899 5.82 56.6599 7.19 62.1199 5.28C50.1399 -1.3 44.4899 6.23 44.4899 6.23C44.3899 6.26 43.1199 4.08 43.9899 0C38.6399 3.04 39.0499 7.56 38.9499 7.49C38.9499 7.49 35.2499 5.4 29.0399 9.25C33.8799 8.84 36.6599 10.64 36.6999 10.84C36.6999 10.84 25.9499 13.96 25.8599 25.36C32.3299 18.89 36.8499 16.31 36.9999 16.38L37.0899 16.29C36.8899 16.23 33.6699 24.08 38.2299 31.35C39.4399 19.82 45.3799 16.34 45.2199 16.04V16.06C45.3099 16.18 53.3899 22.35 60.2799 21.63C56.4599 10.4 47.8899 10.63 47.8899 10.63L47.9099 10.61Z",
    fill: "#FFC000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4699 24.5094C8.14989 22.5394 5.52988 24.4694 1.87988 24.5794C7.45988 17.9794 12.4999 21.1494 12.4999 21.1494C12.5699 21.1494 12.8299 19.5694 11.3799 17.3594C15.2299 17.9494 15.9999 20.6994 16.0499 20.6394C16.0499 20.6394 17.7599 18.5694 22.2999 19.4294C19.3499 20.2894 18.1199 21.9794 18.1399 22.1094C18.1399 22.1094 23.1299 21.9594 24.9599 27.0394C19.6799 24.6894 19.2999 25.3694 19.2199 25.4394L19.1499 25.4094C19.2499 25.3294 22.9299 29.2294 21.8899 34.5594C18.5599 28.0294 14.2699 27.3194 14.2899 27.0994C14.2699 27.1994 10.8999 32.6694 6.66988 33.8094C6.37988 26.3194 11.4899 24.5094 11.4899 24.5094H11.4699Z",
    stroke: "#003D6A",
    strokeWidth: 2.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9097 10.609C51.6897 5.81899 56.6597 7.18899 62.1197 5.27899C50.1397 -1.30101 44.4897 6.22899 44.4897 6.22899C44.4897 6.22899 45.2797 16.109 45.2397 16.039V16.059C45.3297 16.179 53.4098 22.349 60.2998 21.629C56.4798 10.399 47.9097 10.629 47.9097 10.629V10.609Z",
    fill: "#0098C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.01dc09a4c84316de85b6c2c4c6ac5555.svg";
export { ForwardRef as ReactComponent };